// If this file exists, it will ignore the Heroku settings!!! // API_ENDPOINT: 'https://stage-main-street-api.herokuapp.com', 'https://main-street-api.herokuapp.com
export const environment = {
	production: false,
	envName: 'staging',	
	API_ENDPOINT: 'https://stage-main-street-api.herokuapp.com',
	COBE_WEB_SERVICE: 'https://www.companybe.com/API/api.cfc',
	DEFAULT_LOCATION_COUNT: 11
  };
